import React, { useState } from 'react';
import { Button, Input, Modal } from 'antd';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { getResponseFromOpenAPI } from '../../thunks/open_api_thunks';
import { connect } from 'react-redux';

function AIGenerateDocument({ onCancel, onGenerateDocument, getAIResponse }) {
	const [loading, setLoading] = useState(false);
	const [description, setDescription] = useState('');

	const handleGenerateDocument = async () => {
		setLoading(true);
		const systemMessage = `
		      You are a structured document generator that creates content for physical locations such as gyms, restaurants, and retail stores.

Structure:
{
  "title": "string",
  "blocks": [Block array],
  "updatedAt": "ISO-8601"
}

Block format:
{
  "id": "uuid",
  "type": "paragraph"|"heading"|"bulletListItem"|"numberedListItem",
  "props": {"textColor":"default","backgroundColor":"default","textAlignment":"left"},
  "content": [{"type":"text","text":"content","styles":{}}],
  "children": []
}

Heading blocks add: "level": 1|2|3 to props.

Rules:
- Keep content brief (3-6 blocks max)
- Use short, clear text
- Valid types only: paragraph, heading, bulletListItem, numberedListItem
- Each block needs unique id`;

		const userMessage = `Description: ${description}`;

		try {
			const temperature = 0.3;
			const data = await getAIResponse({
				question: {
					model: 'gpt-4o',
					messages: [
						{ role: 'system', content: systemMessage },
						{ role: 'user', content: userMessage },
					],
					temperature,
				},
			});

			const cleanedResponse = nullSafeGetOrElse('title', data, '')
				.replaceAll('\n', '')
				.replaceAll('```json', '')
				.replaceAll('```', '');

			const parsedResponse = JSON.parse(cleanedResponse);

			onGenerateDocument({
				title: nullSafeGet('title', parsedResponse),
				blocks: nullSafeGet('blocks', parsedResponse),
			});
		} catch (error) {
			console.error('Error fetching OpenAI response:', error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<Modal
			title="Start with AI"
			visible
			onCancel={onCancel}
			footer={[
				<Button key="cancel" onClick={onCancel}>
					Cancel
				</Button>,
				<Button
					key="apply"
					type="primary"
					disabled={loading}
					onClick={handleGenerateDocument}
					loading={loading}
				>
					Generate
				</Button>,
			]}
			confirmLoading={loading}
			width={'50vw'}
		>
			<Input.TextArea
				placeholder="Describe the type of template you want (e.g., vendor contract, maintenance checklist)"
				value={description}
				onChange={(e) => setDescription(e.target.value)}
			/>
		</Modal>
	);
}

const mapDispatchToProps = (dispatch) => ({
	getAIResponse: (entity) => dispatch(getResponseFromOpenAPI('buyer')(entity)),
});

export default connect(null, mapDispatchToProps)(AIGenerateDocument);
